import isValid from 'date-fns/isValid';

import { PermissionAction } from '../../../../permissions/permissionsTypes';

import { useCurrentUser } from '../../../../../auth/hooks/useAuth';

import { getDueDate } from '../../../../../utils/getDueDate';

import { formsErrors } from '../../../../../locales/keys';

interface ItemDueDateValidationRulesOptions {
  action: PermissionAction;
  cantBeBlank?: boolean;
  initialDueDate?: string;
}

function useItemDueDateValidationRules({
  action,
  cantBeBlank = true,
  initialDueDate
}: ItemDueDateValidationRulesOptions) {
  const currentUser = useCurrentUser();

  return {
    validate: {
      isValid: (value: string) => {
        if (!value) {
          return cantBeBlank ? formsErrors.dueDate.cantBeBlank : true;
        }

        const newDate = new Date(
          currentUser.hasPermissions(action) ? value : getDueDate(value)
        );

        if (!isValid(newDate)) {
          return formsErrors.dueDate.invalid;
        }

        if (initialDueDate) {
          const oldDate = new Date(initialDueDate);

          if (newDate.getTime() === oldDate.getTime()) {
            return formsErrors.dueDate.notChanged;
          }
        }

        return newDate > new Date() || formsErrors.dueDate.inFuture;
      }
    }
  };
}

export default useItemDueDateValidationRules;
